<template>
  <div class="community">
    <a
      href="https://www.youtube.com/@WE_FIFTYFIFTY"
      target="_blank"
    >
      <img
        src="@/assets/image/yb.png"
        alt="YouTube"
        class="social-icon"
      >
      <p>FIFTY FIFTY YOUTUBE</p>
    </a>
    <a
      href="https://www.instagram.com/we_fiftyfifty"
      target="_blank"
    >
      <img
        src="@/assets/image/is.jpg"
        alt="Instagram"
        class="social-icon"
      >
      <p>FIFTY FIFTY INSTAGRAM</p>
    </a>
    <a
      href="https://www.tiktok.com/@we_fiftyfifty"
      target="_blank"
    >
      <img
        src="@/assets/image/tt.png"
        alt="TikTok"
        class="social-icon"
      >
      <p>FIFTY FIFTY TIKTOK</p>
    </a>
    <a
      href="https://weverse.io/fiftyfifty"
      target="_blank"
    >
      <img
        src="@/assets/image/wb.jpg"
        alt="Weverse"
        class="social-icon"
      >
      <p>FIFTY FIFTY WEVERSE</p>
    </a>
  </div>
</template>



<style scoped src="@/assets/style/mainpage.css"></style>